/**
 * @desc 查询供需审核详情
 */
import { SupplyDemandEntity } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QuerySupplyDemandParameter = {
  id?: string
}

const method = 'GET'
const url = '/trade/operation/supplyDemand'

export const querySupplyDemandApi = (
  params?: QuerySupplyDemandParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<SupplyDemandEntity>({
    method,
    url,
    params,
    ...config
  })
}

querySupplyDemandApi.method = method
querySupplyDemandApi.url = url
